import {
    LeafletPixiApi,
    LeafletPixiApiSettings,
    MapRenderer,
    OperationRenderer
} from "../../../../api/pixijs/renderers/OperationRenderer";
import { HashElement } from "../../../../context/map/units/unitsStore";
import L, { LatLngExpression, Point } from "leaflet";
import { GeoZoneRenderer } from "../../../../api/pixijs/renderers/GeoZoneRenderer";
import { ResetLayerRenderer } from "../../../../api/pixijs/renderers/ResetLayerRenderer";
import { UnitRenderer } from "../../../../api/pixijs/renderers/UnitRenderer";
import TrackRenderer from "../../../../api/pixijs/renderers/unit/TrackRenderer";
import * as PIXI from "pixi.js";
import { groupByProp } from "../../../../utils/utils";
import { Operation } from "../../../../store/reducers/references/operations";
import Logger from "@utils/logger";

export interface PixiOverlayUtils {
    getMap(): L.Map

    getContainer(): PIXI.Container

    latLngToLayerPoint: (latlng: LatLngExpression) => Point

    getScale(): number

    getRenderer(): PIXI.Renderer
}

const log = Logger.getLogger("leaflet.pixi")
export default function (utils: PixiOverlayUtils, map: L.Map, settings: LeafletPixiApiSettings, operations: Operation[]): LeafletPixiApi {
    const service = {
        refreshPixiContainer: function () {
            log.debug("Refresh pixi container...")
            utils.getRenderer().render(utils.getContainer())
        },
        root: utils.getContainer(),
        settings
    }

    const geoZoneRenderer = new GeoZoneRenderer({ service, map }, {
        children: [
            new OperationRenderer({ service, map }, { operations })
        ]
    })
    const resetLayerRenderer = new ResetLayerRenderer({ service, map })
    const unitRenderer = new UnitRenderer({ service, map }, {
        children: [
            new TrackRenderer({ service, map })]
    })

    const renderers = [
        geoZoneRenderer,
            ...geoZoneRenderer.children,
        unitRenderer,
            ...unitRenderer.children,
        resetLayerRenderer,
    ]
    const renderersByName = groupByProp<MapRenderer<HashElement>>('name')(renderers)

    return {
        refreshPixiContainer: service.refreshPixiContainer,
        root: utils.getContainer(),
        getRenderers(): MapRenderer<HashElement>[] {
            return renderers
        },
        getRendererByName<T extends MapRenderer<HashElement>>(k: T['name']): T {
            return renderersByName[k] as T
        }
    }

}